import { render, staticRenderFns } from "./WinModal.vue?vue&type=template&id=7504a4ad&scoped=true"
import script from "./WinModal.vue?vue&type=script&lang=js"
export * from "./WinModal.vue?vue&type=script&lang=js"
import style0 from "./WinModal.vue?vue&type=style&index=0&id=7504a4ad&lang=scss"
import style1 from "./WinModal.vue?vue&type=style&index=1&id=7504a4ad&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7504a4ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/julie/Works/openmetacity/Meta_Land-Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7504a4ad')) {
      api.createRecord('7504a4ad', component.options)
    } else {
      api.reload('7504a4ad', component.options)
    }
    module.hot.accept("./WinModal.vue?vue&type=template&id=7504a4ad&scoped=true", function () {
      api.rerender('7504a4ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Modal/WinModal.vue"
export default component.exports